import reducer, { pricezoneTemplateReducer } from './reducers';

export { pricezoneTemplateReducer };

export default reducer;
